module.exports = __webpack_public_path__ + "assets/seatbelt_buckled.ca2aa356.svg";